import store from '@/state/store'
import { Helper } from '@/mixin/helper'
import * as Address from '@/services/rest-api/lib/delivery/address'
import * as Vehicle from '@/services/rest-api/lib/fleet-task/vehicle'
import * as Driver from '@/services/rest-api/lib/fleet-task/driver'

import { GET_USER_GROUP } from '@/services/api/setting/user/userGroup'

const getFeatureFlagValue = store.getters['identity/getFeatureFlagValue']
const hasAccessAll = store.getters['identity/hasAccessAll']
const hasTmsUserGroupAccess = hasAccessAll(['tms-user-group:read']) && Helper.methods.isSuperUser()

export function tabelFilterFields(instance) {
  return [
    {
      name: 'created_on',
      label: instance.$t('fleetTask.fields.createdDate'),
      type: 'date-picker',
      datepickerType: 'datetime',
      valueType: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
      format: 'DD MMM YYYY HH:mm',
      titleFormat: 'DD MMM YYYY',
      rangeSeparator: ' - ',
      range: true,
      confirm: true,
      confirmText: instance.$t('global.apply'),
      disabledDate: (date) => {
        return date > new Date()
      },
      shortcuts: [
        {
          text: instance.$t('global.time.today'),
          onClick: () => {
            const startDate = new Date()
            const endDate = new Date()

            startDate.setHours(0, 0, 0)
            endDate.setHours(23, 59, 59)

            return [startDate, endDate]
          },
        },
        {
          text: instance.$t('global.time.yesterday'),
          onClick: () => {
            const startDate = new Date()
            const endDate = new Date()

            startDate.setDate(startDate.getDate() - 1)
            startDate.setHours(0, 0, 0)

            endDate.setDate(endDate.getDate() - 1)
            endDate.setHours(23, 59, 59)

            return [startDate, endDate]
          },
        },
        {
          text: instance.$t('global.time.last3Days'),
          onClick: () => {
            const startDate = new Date()
            const endDate = new Date()

            startDate.setDate(startDate.getDate() - 3)
            startDate.setHours(0, 0, 0)
            endDate.setHours(23, 59, 59)

            return [startDate, endDate]
          },
        },
        {
          text: instance.$t('global.time.last7Days'),
          onClick: () => {
            const startDate = new Date()
            const endDate = new Date()

            startDate.setDate(startDate.getDate() - 7)
            startDate.setHours(0, 0, 0)
            endDate.setHours(23, 59, 59)

            return [startDate, endDate]
          },
        },
      ],
    },
    {
      name: 'expected_departure_on',
      label: instance.$t('fleetTask.fields.departureTime'),
      type: 'date-picker',
      datepickerType: 'datetime',
      valueType: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
      format: 'DD MMM YYYY HH:mm',
      titleFormat: 'DD MMM YYYY',
      rangeSeparator: ' - ',
      range: true,
      confirm: true,
      confirmText: instance.$t('global.apply'),
      disabledDate: (date) => {
        return date > new Date()
      },
      shortcuts: [
        {
          text: instance.$t('global.time.today'),
          onClick: () => {
            const startDate = new Date()
            const endDate = new Date()

            startDate.setHours(0, 0, 0)
            endDate.setHours(23, 59, 59)

            return [startDate, endDate]
          },
        },
        {
          text: instance.$t('global.time.yesterday'),
          onClick: () => {
            const startDate = new Date()
            const endDate = new Date()

            startDate.setDate(startDate.getDate() - 1)
            startDate.setHours(0, 0, 0)

            endDate.setDate(endDate.getDate() - 1)
            endDate.setHours(23, 59, 59)

            return [startDate, endDate]
          },
        },
        {
          text: instance.$t('global.time.last3Days'),
          onClick: () => {
            const startDate = new Date()
            const endDate = new Date()

            startDate.setDate(startDate.getDate() - 3)
            startDate.setHours(0, 0, 0)
            endDate.setHours(23, 59, 59)

            return [startDate, endDate]
          },
        },
        {
          text: instance.$t('global.time.last7Days'),
          onClick: () => {
            const startDate = new Date()
            const endDate = new Date()

            startDate.setDate(startDate.getDate() - 7)
            startDate.setHours(0, 0, 0)
            endDate.setHours(23, 59, 59)

            return [startDate, endDate]
          },
        },
      ],
    },
    {
      name: 'user_group_id',
      isShow: hasTmsUserGroupAccess,
      label: instance.$t('global.field.userGroup'),
      type: 'value-help-v2',
      placeholder: `${instance.$t('global.form.select')} ${instance.$t('global.field.userGroup')}`,
      trackBy: 'id',
      displayedBy: 'name',
      listGetter: async function (opts) {
        let result = {}
        const filter = {
          pagination: {
            page: opts?.page,
            show: opts?.limit,
          },
          search: opts?.search,
        }

        const res = await this.$apollo.query({
          query: GET_USER_GROUP,
          fetchPolicy: 'no-cache',
          variables: {
            filter: {
              ...filter,
            },
          },
        })

        const ugroups = res.data.ugroups.ugroups

        result = {
          metadata: {
            total_count: ugroups.pagination.total,
            page: ugroups.pagination.page,
          },
          data: {
            paginated_result: ugroups.data,
          },
        }

        return result
      },
      multiple: true,
      tableFields: [
        {
          label: instance.$t('global.field.userGroup'),
          key: 'name',
          isSortable: false,
        },
        {
          label: instance.$t('global.field.vehicleGroup'),
          key: 'vgroups',
          isSortable: false,
          formatter: (value) => {
            return value?.length != null
              ? value.length === 0
                ? instance.$t('global.text.allVehicleGroup')
                : value.length
              : '-'
          },
        },
      ],
    },
    {
      name: 'start_address_id',
      isShow: true,
      label: instance.$t('fleetTask.fields.startingPoint'),
      type: 'value-help-v2',
      placeholder: instance.$t('fleetTask.placeholder.startingPoint'),
      trackBy: 'id',
      displayedBy: 'name',
      listGetter: Address.get('is_garage eq true'),
      multiple: true,
      tableFields: [
        {
          label: instance.$t('fleetTask.fields.garage'),
          key: 'name',
          isSortable: true,
        },
        {
          label: instance.$t('fleetTask.fields.city'),
          key: 'city',
          isSortable: true,
        },
      ],
    },
    {
      name: 'vehicle_id',
      isShow: true,
      label: instance.$t('fleetTask.fields.licensePlate'),
      type: 'value-help-v2',
      placeholder: instance.$t('fleetTask.placeholder.licensePlate'),
      trackBy: 'id',
      displayedBy: 'license_plate',
      subKey: 'hull_no',
      listGetter: (queryParam) => {
        queryParam.filters = queryParam.filters ? queryParam.filters : []
        const vgroupIds = store.state.access.vGroups.map((vgroup) => vgroup.id)
        if (vgroupIds.length > 0) {
          queryParam.filters.push(`vehicle_group.id in (${vgroupIds.join(', ')})`)
        }

        return Vehicle.get(queryParam)
      },
      multiple: true,
      tableFields: [
        {
          label: instance.$t('fleetTask.fields.licensePlate'),
          key: 'license_plate',
          isSortable: true,
          isSlot: true,
          slotComponent: 'DynamicCell',
          subKey: 'hull_no',
        },
        {
          label: instance.$t('fleetTask.fields.vehicleType'),
          key: 'vehicle_type.type',
          isSortable: true,
        },
        {
          label: instance.$t('fleetTask.fields.boxType'),
          key: 'box_type.name',
          isSortable: true,
        },
      ],
    },
    {
      name: 'driver_user_id',
      isShow: true,
      label: instance.$t('global.field.primaryDriver'),
      type: 'value-help-v2',
      placeholder: instance.$t('fleetTask.placeholder.primaryDriver'),
      trackBy: 'id',
      displayedBy: 'name',
      listGetter: (queryParam) => {
        queryParam.filters = queryParam.filters ? queryParam.filters : []
        if (hasAccessAll(['tms-user-group:read']) && !Helper.methods.isSuperUser()) {
          queryParam.filters.push(`ugroup.id eq ${store.state.identity.whoami?.groups[0].id}`)
        }

        return Driver.get(queryParam)
      },
      multiple: true,
      tableFields: [
        {
          label: instance.$t('global.field.primaryDriver'),
          key: 'name',
          isSortable: true,
        },
      ],
    },
    {
      name: 'driver_user_2_id',
      isShow: true,
      label: instance.$t('global.field.additionalDriver'),
      type: 'value-help-v2',
      placeholder: instance.$t('fleetTask.placeholder.additionalDriver'),
      trackBy: 'id',
      displayedBy: 'name',
      listGetter: (queryParam) => {
        queryParam.filters = queryParam.filters ? queryParam.filters : []
        if (hasAccessAll(['tms-user-group:read']) && !Helper.methods.isSuperUser()) {
          queryParam.filters.push(`ugroup.id eq ${store.state.identity.whoami?.groups[0].id}`)
        }

        return Driver.get(queryParam)
      },
      multiple: true,
      tableFields: [
        {
          label: instance.$t('global.field.additionalDriver'),
          key: 'name',
          isSortable: true,
        },
      ],
    },
    {
      type: 'range-input',
      label: instance.$t('fleetTask.fields.totalWeight'),
      min: {
        name: 'load_weight_min',
        label: instance.$t('fleetTask.fields.minimal'),
        type: 'number',
        validation: 'bail|number|min:0,value',
        suffix: 'Kg',
        'validation-behavior': 'live',
      },
      max: {
        name: 'load_weight_max',
        label: instance.$t('fleetTask.fields.maximal'),
        type: 'number',
        validation: 'bail|number|min:0,value',
        suffix: 'Kg',
        'validation-behavior': 'live',
      },
    },
    {
      type: 'range-input',
      label: instance.$t('fleetTask.fields.totalVolume'),
      min: {
        name: 'load_volume_min',
        label: instance.$t('fleetTask.fields.minimal'),
        type: 'number',
        validation: 'bail|number|min:0,value',
        suffix: 'Cbm',
        'validation-behavior': 'live',
      },
      max: {
        name: 'load_volume_max',
        label: instance.$t('fleetTask.fields.maximal'),
        type: 'number',
        validation: 'bail|number|min:0,value',
        suffix: 'Cbm',
        'validation-behavior': 'live',
      },
    },
  ]
}
